import { render } from "./DefaultOnepagePostRelatedSectionNewsCmp.vue?vue&type=template&id=36d96c36"
import script from "./DefaultOnepagePostRelatedSectionNewsCmp.vue?vue&type=script&lang=js"
export * from "./DefaultOnepagePostRelatedSectionNewsCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__